"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
require("core-js/modules/es6.function.name.js");
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.regexp.replace.js");
require("core-js/modules/es6.regexp.constructor.js");
var _size = _interopRequireDefault(require("lodash/size"));
var _utils = require("@gravity/utils");
function cov_1jr4b4ipu4() {
  var path = "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductHelper.js";
  var hash = "65ecb5fc6f8e8f3d03c6cc4ab249f8c2f23a2025";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductHelper.js",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 9,
          column: 23
        }
      },
      "1": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 19,
          column: 3
        }
      },
      "2": {
        start: {
          line: 11,
          column: 19
        },
        end: {
          line: 11,
          column: 89
        }
      },
      "3": {
        start: {
          line: 12,
          column: 39
        },
        end: {
          line: 12,
          column: 50
        }
      },
      "4": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 69
        }
      },
      "5": {
        start: {
          line: 15,
          column: 9
        },
        end: {
          line: 19,
          column: 3
        }
      },
      "6": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 36
        }
      },
      "7": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 32
        }
      },
      "8": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 22
        }
      },
      "9": {
        start: {
          line: 24,
          column: 20
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "10": {
        start: {
          line: 25,
          column: 19
        },
        end: {
          line: 27,
          column: 49
        }
      },
      "11": {
        start: {
          line: 26,
          column: 17
        },
        end: {
          line: 26,
          column: 42
        }
      },
      "12": {
        start: {
          line: 27,
          column: 21
        },
        end: {
          line: 27,
          column: 43
        }
      },
      "13": {
        start: {
          line: 28,
          column: 15
        },
        end: {
          line: 28,
          column: 24
        }
      },
      "14": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "15": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 35
        }
      },
      "16": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 14
        }
      },
      "17": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 41,
          column: 3
        }
      },
      "18": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 43
        }
      },
      "19": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 42,
          column: 26
        }
      },
      "20": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 49,
          column: 3
        }
      },
      "21": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 28
        }
      },
      "22": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 52,
          column: 3
        }
      },
      "23": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 25
        }
      },
      "24": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 55,
          column: 3
        }
      },
      "25": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 35
        }
      },
      "26": {
        start: {
          line: 57,
          column: 2
        },
        end: {
          line: 59,
          column: 3
        }
      },
      "27": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 24
        }
      },
      "28": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 60,
          column: 14
        }
      },
      "29": {
        start: {
          line: 63,
          column: 37
        },
        end: {
          line: 98,
          column: 1
        }
      },
      "30": {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 66,
          column: 3
        }
      },
      "31": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 16
        }
      },
      "32": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 96,
          column: 3
        }
      },
      "33": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 76,
          column: 5
        }
      },
      "34": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 95,
          column: 6
        }
      },
      "35": {
        start: {
          line: 97,
          column: 2
        },
        end: {
          line: 97,
          column: 38
        }
      },
      "36": {
        start: {
          line: 100,
          column: 39
        },
        end: {
          line: 132,
          column: 1
        }
      },
      "37": {
        start: {
          line: 101,
          column: 2
        },
        end: {
          line: 103,
          column: 3
        }
      },
      "38": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 16
        }
      },
      "39": {
        start: {
          line: 104,
          column: 22
        },
        end: {
          line: 107,
          column: 5
        }
      },
      "40": {
        start: {
          line: 104,
          column: 38
        },
        end: {
          line: 107,
          column: 3
        }
      },
      "41": {
        start: {
          line: 109,
          column: 2
        },
        end: {
          line: 129,
          column: 3
        }
      },
      "42": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 117,
          column: 6
        }
      },
      "43": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 128,
          column: 6
        }
      },
      "44": {
        start: {
          line: 131,
          column: 2
        },
        end: {
          line: 131,
          column: 38
        }
      },
      "45": {
        start: {
          line: 134,
          column: 27
        },
        end: {
          line: 141,
          column: 1
        }
      },
      "46": {
        start: {
          line: 135,
          column: 20
        },
        end: {
          line: 135,
          column: 49
        }
      },
      "47": {
        start: {
          line: 136,
          column: 16
        },
        end: {
          line: 136,
          column: 65
        }
      },
      "48": {
        start: {
          line: 137,
          column: 18
        },
        end: {
          line: 137,
          column: 33
        }
      },
      "49": {
        start: {
          line: 138,
          column: 2
        },
        end: {
          line: 138,
          column: 28
        }
      },
      "50": {
        start: {
          line: 138,
          column: 16
        },
        end: {
          line: 138,
          column: 28
        }
      },
      "51": {
        start: {
          line: 139,
          column: 2
        },
        end: {
          line: 139,
          column: 29
        }
      },
      "52": {
        start: {
          line: 139,
          column: 19
        },
        end: {
          line: 139,
          column: 29
        }
      },
      "53": {
        start: {
          line: 140,
          column: 2
        },
        end: {
          line: 140,
          column: 60
        }
      },
      "54": {
        start: {
          line: 143,
          column: 42
        },
        end: {
          line: 150,
          column: 1
        }
      },
      "55": {
        start: {
          line: 144,
          column: 37
        },
        end: {
          line: 144,
          column: 79
        }
      },
      "56": {
        start: {
          line: 145,
          column: 2
        },
        end: {
          line: 148,
          column: 3
        }
      },
      "57": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 147,
          column: 41
        }
      },
      "58": {
        start: {
          line: 149,
          column: 2
        },
        end: {
          line: 149,
          column: 55
        }
      },
      "59": {
        start: {
          line: 152,
          column: 22
        },
        end: {
          line: 167,
          column: 1
        }
      },
      "60": {
        start: {
          line: 154,
          column: 20
        },
        end: {
          line: 154,
          column: 84
        }
      },
      "61": {
        start: {
          line: 156,
          column: 2
        },
        end: {
          line: 156,
          column: 44
        }
      },
      "62": {
        start: {
          line: 157,
          column: 2
        },
        end: {
          line: 162,
          column: 3
        }
      },
      "63": {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 158,
          column: 109
        }
      },
      "64": {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 161,
          column: 5
        }
      },
      "65": {
        start: {
          line: 160,
          column: 6
        },
        end: {
          line: 160,
          column: 48
        }
      },
      "66": {
        start: {
          line: 163,
          column: 27
        },
        end: {
          line: 163,
          column: 106
        }
      },
      "67": {
        start: {
          line: 164,
          column: 2
        },
        end: {
          line: 166,
          column: 3
        }
      },
      "68": {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 165,
          column: 44
        }
      },
      "69": {
        start: {
          line: 170,
          column: 22
        },
        end: {
          line: 178,
          column: 1
        }
      },
      "70": {
        start: {
          line: 171,
          column: 52
        },
        end: {
          line: 171,
          column: 75
        }
      },
      "71": {
        start: {
          line: 172,
          column: 2
        },
        end: {
          line: 174,
          column: 3
        }
      },
      "72": {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 173,
          column: 53
        }
      },
      "73": {
        start: {
          line: 175,
          column: 2
        },
        end: {
          line: 177,
          column: 3
        }
      },
      "74": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 27
        }
      },
      "75": {
        start: {
          line: 188,
          column: 25
        },
        end: {
          line: 199,
          column: 1
        }
      },
      "76": {
        start: {
          line: 189,
          column: 75
        },
        end: {
          line: 189,
          column: 80
        }
      },
      "77": {
        start: {
          line: 190,
          column: 2
        },
        end: {
          line: 194,
          column: 3
        }
      },
      "78": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 193,
          column: 6
        }
      },
      "79": {
        start: {
          line: 192,
          column: 21
        },
        end: {
          line: 192,
          column: 107
        }
      },
      "80": {
        start: {
          line: 195,
          column: 15
        },
        end: {
          line: 195,
          column: 45
        }
      },
      "81": {
        start: {
          line: 197,
          column: 2
        },
        end: {
          line: 197,
          column: 116
        }
      },
      "82": {
        start: {
          line: 198,
          column: 2
        },
        end: {
          line: 198,
          column: 123
        }
      },
      "83": {
        start: {
          line: 198,
          column: 26
        },
        end: {
          line: 198,
          column: 106
        }
      }
    },
    fnMap: {
      "0": {
        name: "getProductTitle",
        decl: {
          start: {
            line: 8,
            column: 9
          },
          end: {
            line: 8,
            column: 24
          }
        },
        loc: {
          start: {
            line: 8,
            column: 77
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 20
          },
          end: {
            line: 24,
            column: 21
          }
        },
        loc: {
          start: {
            line: 24,
            column: 41
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 24
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 26,
            column: 10
          },
          end: {
            line: 26,
            column: 11
          }
        },
        loc: {
          start: {
            line: 26,
            column: 17
          },
          end: {
            line: 26,
            column: 42
          }
        },
        line: 26
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 27,
            column: 10
          },
          end: {
            line: 27,
            column: 11
          }
        },
        loc: {
          start: {
            line: 27,
            column: 21
          },
          end: {
            line: 27,
            column: 43
          }
        },
        line: 27
      },
      "4": {
        name: "getProductSubtitle",
        decl: {
          start: {
            line: 38,
            column: 9
          },
          end: {
            line: 38,
            column: 27
          }
        },
        loc: {
          start: {
            line: 38,
            column: 54
          },
          end: {
            line: 43,
            column: 1
          }
        },
        line: 38
      },
      "5": {
        name: "getVariableByKey",
        decl: {
          start: {
            line: 45,
            column: 9
          },
          end: {
            line: 45,
            column: 25
          }
        },
        loc: {
          start: {
            line: 45,
            column: 83
          },
          end: {
            line: 61,
            column: 1
          }
        },
        line: 45
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 63,
            column: 37
          },
          end: {
            line: 63,
            column: 38
          }
        },
        loc: {
          start: {
            line: 63,
            column: 72
          },
          end: {
            line: 98,
            column: 1
          }
        },
        line: 63
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 100,
            column: 39
          },
          end: {
            line: 100,
            column: 40
          }
        },
        loc: {
          start: {
            line: 100,
            column: 74
          },
          end: {
            line: 132,
            column: 1
          }
        },
        line: 100
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 104,
            column: 31
          },
          end: {
            line: 104,
            column: 32
          }
        },
        loc: {
          start: {
            line: 104,
            column: 38
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 104
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 134,
            column: 27
          },
          end: {
            line: 134,
            column: 28
          }
        },
        loc: {
          start: {
            line: 134,
            column: 40
          },
          end: {
            line: 141,
            column: 1
          }
        },
        line: 134
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 143,
            column: 42
          },
          end: {
            line: 143,
            column: 43
          }
        },
        loc: {
          start: {
            line: 143,
            column: 65
          },
          end: {
            line: 150,
            column: 1
          }
        },
        line: 143
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 152,
            column: 22
          },
          end: {
            line: 152,
            column: 23
          }
        },
        loc: {
          start: {
            line: 152,
            column: 54
          },
          end: {
            line: 167,
            column: 1
          }
        },
        line: 152
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 170,
            column: 22
          },
          end: {
            line: 170,
            column: 23
          }
        },
        loc: {
          start: {
            line: 170,
            column: 91
          },
          end: {
            line: 178,
            column: 1
          }
        },
        line: 170
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 188,
            column: 25
          },
          end: {
            line: 188,
            column: 26
          }
        },
        loc: {
          start: {
            line: 188,
            column: 45
          },
          end: {
            line: 199,
            column: 1
          }
        },
        line: 188
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 192,
            column: 15
          },
          end: {
            line: 192,
            column: 16
          }
        },
        loc: {
          start: {
            line: 192,
            column: 21
          },
          end: {
            line: 192,
            column: 107
          }
        },
        line: 192
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 198,
            column: 20
          },
          end: {
            line: 198,
            column: 21
          }
        },
        loc: {
          start: {
            line: 198,
            column: 26
          },
          end: {
            line: 198,
            column: 106
          }
        },
        line: 198
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        }, {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 19,
            column: 3
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 10,
            column: 6
          },
          end: {
            line: 10,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 10,
            column: 6
          },
          end: {
            line: 10,
            column: 46
          }
        }, {
          start: {
            line: 10,
            column: 50
          },
          end: {
            line: 10,
            column: 61
          }
        }],
        line: 10
      },
      "2": {
        loc: {
          start: {
            line: 11,
            column: 19
          },
          end: {
            line: 11,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 11,
            column: 20
          },
          end: {
            line: 11,
            column: 24
          }
        }, {
          start: {
            line: 11,
            column: 28
          },
          end: {
            line: 11,
            column: 80
          }
        }, {
          start: {
            line: 11,
            column: 85
          },
          end: {
            line: 11,
            column: 89
          }
        }],
        line: 11
      },
      "3": {
        loc: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 19,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 19,
            column: 3
          }
        }, {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 19,
            column: 3
          }
        }],
        line: 15
      },
      "4": {
        loc: {
          start: {
            line: 15,
            column: 13
          },
          end: {
            line: 15,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 13
          },
          end: {
            line: 15,
            column: 31
          }
        }, {
          start: {
            line: 15,
            column: 35
          },
          end: {
            line: 15,
            column: 46
          }
        }],
        line: 15
      },
      "5": {
        loc: {
          start: {
            line: 26,
            column: 17
          },
          end: {
            line: 26,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 17
          },
          end: {
            line: 26,
            column: 24
          }
        }, {
          start: {
            line: 26,
            column: 28
          },
          end: {
            line: 26,
            column: 42
          }
        }],
        line: 26
      },
      "6": {
        loc: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 29
      },
      "7": {
        loc: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 39
      },
      "8": {
        loc: {
          start: {
            line: 40,
            column: 11
          },
          end: {
            line: 40,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 40,
            column: 25
          },
          end: {
            line: 40,
            column: 37
          }
        }, {
          start: {
            line: 40,
            column: 40
          },
          end: {
            line: 40,
            column: 42
          }
        }],
        line: 40
      },
      "9": {
        loc: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 47
      },
      "10": {
        loc: {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 17
          }
        }, {
          start: {
            line: 47,
            column: 21
          },
          end: {
            line: 47,
            column: 75
          }
        }],
        line: 47
      },
      "11": {
        loc: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 50
      },
      "12": {
        loc: {
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 50,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 50,
            column: 14
          }
        }, {
          start: {
            line: 50,
            column: 18
          },
          end: {
            line: 50,
            column: 69
          }
        }],
        line: 50
      },
      "13": {
        loc: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 53
      },
      "14": {
        loc: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 24
          }
        }, {
          start: {
            line: 53,
            column: 28
          },
          end: {
            line: 53,
            column: 89
          }
        }],
        line: 53
      },
      "15": {
        loc: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 57
      },
      "16": {
        loc: {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 57,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 57,
            column: 13
          }
        }, {
          start: {
            line: 57,
            column: 17
          },
          end: {
            line: 57,
            column: 67
          }
        }],
        line: 57
      },
      "17": {
        loc: {
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 64
      },
      "18": {
        loc: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 96,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 96,
            column: 3
          }
        }, {
          start: {
            line: 77,
            column: 9
          },
          end: {
            line: 96,
            column: 3
          }
        }],
        line: 68
      },
      "19": {
        loc: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 103,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 103,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 101
      },
      "20": {
        loc: {
          start: {
            line: 104,
            column: 38
          },
          end: {
            line: 107,
            column: 3
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 104,
            column: 47
          },
          end: {
            line: 104,
            column: 115
          }
        }, {
          start: {
            line: 104,
            column: 118
          },
          end: {
            line: 107,
            column: 3
          }
        }],
        line: 104
      },
      "21": {
        loc: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 129,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 129,
            column: 3
          }
        }, {
          start: {
            line: 118,
            column: 9
          },
          end: {
            line: 129,
            column: 3
          }
        }],
        line: 109
      },
      "22": {
        loc: {
          start: {
            line: 138,
            column: 2
          },
          end: {
            line: 138,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 138,
            column: 2
          },
          end: {
            line: 138,
            column: 28
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 138
      },
      "23": {
        loc: {
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 139,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 139,
            column: 29
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 139
      },
      "24": {
        loc: {
          start: {
            line: 145,
            column: 2
          },
          end: {
            line: 148,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 145,
            column: 2
          },
          end: {
            line: 148,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 145
      },
      "25": {
        loc: {
          start: {
            line: 156,
            column: 21
          },
          end: {
            line: 156,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 156,
            column: 21
          },
          end: {
            line: 156,
            column: 37
          }
        }, {
          start: {
            line: 156,
            column: 41
          },
          end: {
            line: 156,
            column: 43
          }
        }],
        line: 156
      },
      "26": {
        loc: {
          start: {
            line: 157,
            column: 2
          },
          end: {
            line: 162,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 2
          },
          end: {
            line: 162,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 157
      },
      "27": {
        loc: {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 159
      },
      "28": {
        loc: {
          start: {
            line: 164,
            column: 2
          },
          end: {
            line: 166,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 164,
            column: 2
          },
          end: {
            line: 166,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 164
      },
      "29": {
        loc: {
          start: {
            line: 172,
            column: 2
          },
          end: {
            line: 174,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 172,
            column: 2
          },
          end: {
            line: 174,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 172
      },
      "30": {
        loc: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 177,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 177,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 175
      },
      "31": {
        loc: {
          start: {
            line: 190,
            column: 2
          },
          end: {
            line: 194,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 190,
            column: 2
          },
          end: {
            line: 194,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 190
      },
      "32": {
        loc: {
          start: {
            line: 192,
            column: 44
          },
          end: {
            line: 192,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 192,
            column: 44
          },
          end: {
            line: 192,
            column: 55
          }
        }, {
          start: {
            line: 192,
            column: 59
          },
          end: {
            line: 192,
            column: 66
          }
        }],
        line: 192
      },
      "33": {
        loc: {
          start: {
            line: 195,
            column: 15
          },
          end: {
            line: 195,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 195,
            column: 33
          },
          end: {
            line: 195,
            column: 39
          }
        }, {
          start: {
            line: 195,
            column: 42
          },
          end: {
            line: 195,
            column: 45
          }
        }],
        line: 195
      },
      "34": {
        loc: {
          start: {
            line: 197,
            column: 11
          },
          end: {
            line: 197,
            column: 115
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 197,
            column: 63
          },
          end: {
            line: 197,
            column: 106
          }
        }, {
          start: {
            line: 197,
            column: 109
          },
          end: {
            line: 197,
            column: 115
          }
        }],
        line: 197
      },
      "35": {
        loc: {
          start: {
            line: 198,
            column: 52
          },
          end: {
            line: 198,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 198,
            column: 52
          },
          end: {
            line: 198,
            column: 63
          }
        }, {
          start: {
            line: 198,
            column: 67
          },
          end: {
            line: 198,
            column: 74
          }
        }],
        line: 198
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "65ecb5fc6f8e8f3d03c6cc4ab249f8c2f23a2025"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1jr4b4ipu4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1jr4b4ipu4();
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Given a product in parameters, return the title for the product
 */
function getProductTitle(_ref) {
  var product = _ref.product,
    performance = _ref.performance,
    intl = _ref.intl,
    usePerformanceName = _ref.usePerformanceName;
  cov_1jr4b4ipu4().f[0]++;
  var productTitle = (cov_1jr4b4ipu4().s[0]++, '');
  cov_1jr4b4ipu4().s[1]++;
  if ((cov_1jr4b4ipu4().b[1][0]++, product.productType === 'SPORTING_EVENT') && (cov_1jr4b4ipu4().b[1][1]++, performance)) {
    cov_1jr4b4ipu4().b[0][0]++;
    var versus = (cov_1jr4b4ipu4().s[2]++, (cov_1jr4b4ipu4().b[2][0]++, intl) && (cov_1jr4b4ipu4().b[2][1]++, intl.formatMessage({
      id: 'gravity.Product.versus'
    })) || (cov_1jr4b4ipu4().b[2][2]++, 'vs'));
    var _ref2 = (cov_1jr4b4ipu4().s[3]++, performance),
      hostTeam = _ref2.hostTeam,
      opposingTeam = _ref2.opposingTeam;
    cov_1jr4b4ipu4().s[4]++;
    productTitle = "".concat(hostTeam.name, " ").concat(versus, " ").concat(opposingTeam.name);
  } else {
    cov_1jr4b4ipu4().b[0][1]++;
    cov_1jr4b4ipu4().s[5]++;
    if ((cov_1jr4b4ipu4().b[4][0]++, usePerformanceName) && (cov_1jr4b4ipu4().b[4][1]++, performance)) {
      cov_1jr4b4ipu4().b[3][0]++;
      cov_1jr4b4ipu4().s[6]++;
      productTitle = performance.name;
    } else {
      cov_1jr4b4ipu4().b[3][1]++;
      cov_1jr4b4ipu4().s[7]++;
      productTitle = product.name;
    }
  }
  cov_1jr4b4ipu4().s[8]++;
  return productTitle;
}
cov_1jr4b4ipu4().s[9]++;
var addUserInfo = function addUserInfo(dataLayer, user) {
  cov_1jr4b4ipu4().f[1]++;
  var userData = (cov_1jr4b4ipu4().s[10]++, (0, _keys.default)(user).filter(function (k) {
    cov_1jr4b4ipu4().f[2]++;
    cov_1jr4b4ipu4().s[11]++;
    return (cov_1jr4b4ipu4().b[5][0]++, user[k]) && (cov_1jr4b4ipu4().b[5][1]++, user[k] !== '');
  }).reduce(function (a, k) {
    cov_1jr4b4ipu4().f[3]++;
    cov_1jr4b4ipu4().s[12]++;
    return _objectSpread(_objectSpread({}, a), {}, (0, _defineProperty2.default)({}, k, user[k]));
  }, {}));
  var data = (cov_1jr4b4ipu4().s[13]++, dataLayer);
  cov_1jr4b4ipu4().s[14]++;
  if ((0, _keys.default)(userData).length > 0) {
    cov_1jr4b4ipu4().b[6][0]++;
    cov_1jr4b4ipu4().s[15]++;
    data.ecommerce.user = userData;
  } else {
    cov_1jr4b4ipu4().b[6][1]++;
  }
  cov_1jr4b4ipu4().s[16]++;
  return data;
};

/*
 * Given a product in parameters, return the subtitle for the product
 */
function getProductSubtitle(_ref3) {
  var product = _ref3.product,
    performance = _ref3.performance;
  cov_1jr4b4ipu4().f[4]++;
  cov_1jr4b4ipu4().s[17]++;
  if (product.productType === 'SPORTING_EVENT') {
    cov_1jr4b4ipu4().b[7][0]++;
    cov_1jr4b4ipu4().s[18]++;
    return performance ? (cov_1jr4b4ipu4().b[8][0]++, product.name) : (cov_1jr4b4ipu4().b[8][1]++, '');
  } else {
    cov_1jr4b4ipu4().b[7][1]++;
  }
  cov_1jr4b4ipu4().s[19]++;
  return product.subtitle;
}
function getVariableByKey(product, performance, timeslot, hospitalitySession, key) {
  cov_1jr4b4ipu4().f[5]++;
  cov_1jr4b4ipu4().s[20]++;
  // the variable is either in performance / timeslot / product / hospitality session
  if ((cov_1jr4b4ipu4().b[10][0]++, performance) && (cov_1jr4b4ipu4().b[10][1]++, Object.prototype.hasOwnProperty.call(performance, key))) {
    cov_1jr4b4ipu4().b[9][0]++;
    cov_1jr4b4ipu4().s[21]++;
    return performance[key];
  } else {
    cov_1jr4b4ipu4().b[9][1]++;
  }
  cov_1jr4b4ipu4().s[22]++;
  if ((cov_1jr4b4ipu4().b[12][0]++, timeslot) && (cov_1jr4b4ipu4().b[12][1]++, Object.prototype.hasOwnProperty.call(timeslot, key))) {
    cov_1jr4b4ipu4().b[11][0]++;
    cov_1jr4b4ipu4().s[23]++;
    return timeslot[key];
  } else {
    cov_1jr4b4ipu4().b[11][1]++;
  }
  cov_1jr4b4ipu4().s[24]++;
  if ((cov_1jr4b4ipu4().b[14][0]++, hospitalitySession) && (cov_1jr4b4ipu4().b[14][1]++, Object.prototype.hasOwnProperty.call(hospitalitySession, key))) {
    cov_1jr4b4ipu4().b[13][0]++;
    cov_1jr4b4ipu4().s[25]++;
    return hospitalitySession[key];
  } else {
    cov_1jr4b4ipu4().b[13][1]++;
  }
  cov_1jr4b4ipu4().s[26]++;
  if ((cov_1jr4b4ipu4().b[16][0]++, product) && (cov_1jr4b4ipu4().b[16][1]++, Object.prototype.hasOwnProperty.call(product, key))) {
    cov_1jr4b4ipu4().b[15][0]++;
    cov_1jr4b4ipu4().s[27]++;
    return product[key];
  } else {
    cov_1jr4b4ipu4().b[15][1]++;
  }
  cov_1jr4b4ipu4().s[28]++;
  return null;
}
cov_1jr4b4ipu4().s[29]++;
var buildOnClickProductDataLayer = function buildOnClickProductDataLayer(data, user, orderType, useGA4) {
  cov_1jr4b4ipu4().f[6]++;
  cov_1jr4b4ipu4().s[30]++;
  if (!data) {
    cov_1jr4b4ipu4().b[17][0]++;
    cov_1jr4b4ipu4().s[31]++;
    return null;
  } else {
    cov_1jr4b4ipu4().b[17][1]++;
  }
  var dataLayer;
  cov_1jr4b4ipu4().s[32]++;
  if (useGA4) {
    cov_1jr4b4ipu4().b[18][0]++;
    cov_1jr4b4ipu4().s[33]++;
    dataLayer = {
      event: 'select_item',
      ecommerce: {
        items: [_objectSpread({}, (0, _utils.convertToGA4Attribute)(_utils.GA4EventEnum.productClick, data, orderType))]
      }
    };
  } else {
    cov_1jr4b4ipu4().b[18][1]++;
    cov_1jr4b4ipu4().s[34]++;
    dataLayer = {
      event: 'ee-productClick',
      ecommerce: {
        click: {
          actionField: {
            list: data.list
          },
          products: [{
            id: data.id,
            name: data.name,
            brand: data.brand,
            type: data.type,
            position: data.position,
            variant: orderType
          }]
        }
      }
    };
  }
  cov_1jr4b4ipu4().s[35]++;
  return addUserInfo(dataLayer, user);
};
cov_1jr4b4ipu4().s[36]++;
var buildOnClickAdvantageDataLayer = function buildOnClickAdvantageDataLayer(data, user, orderType, useGA4) {
  cov_1jr4b4ipu4().f[7]++;
  cov_1jr4b4ipu4().s[37]++;
  if (!data) {
    cov_1jr4b4ipu4().b[19][0]++;
    cov_1jr4b4ipu4().s[38]++;
    return null;
  } else {
    cov_1jr4b4ipu4().b[19][1]++;
  }
  var convertData = (cov_1jr4b4ipu4().s[39]++, data.map(function (el) {
    cov_1jr4b4ipu4().f[8]++;
    cov_1jr4b4ipu4().s[40]++;
    return useGA4 ? (cov_1jr4b4ipu4().b[20][0]++, _objectSpread({}, (0, _utils.convertToGA4Attribute)(_utils.GA4EventEnum.promoClick, el, orderType))) : (cov_1jr4b4ipu4().b[20][1]++, _objectSpread(_objectSpread({}, el), {}, {
      variant: orderType
    }));
  }));
  var dataLayer;
  cov_1jr4b4ipu4().s[41]++;
  if (useGA4) {
    cov_1jr4b4ipu4().b[21][0]++;
    cov_1jr4b4ipu4().s[42]++;
    dataLayer = {
      event: 'select_promotion',
      ecommerce: {
        items: (0, _toConsumableArray2.default)(convertData)
      }
    };
  } else {
    cov_1jr4b4ipu4().b[21][1]++;
    cov_1jr4b4ipu4().s[43]++;
    dataLayer = {
      event: 'ee-promoClick',
      ecommerce: {
        promoClick: {
          promotions: (0, _toConsumableArray2.default)(convertData)
        }
      }
    };
  }
  cov_1jr4b4ipu4().s[44]++;
  return addUserInfo(dataLayer, user);
};
cov_1jr4b4ipu4().s[45]++;
var getParameterByName = function getParameterByName(name, url) {
  cov_1jr4b4ipu4().f[9]++;
  var paramName = (cov_1jr4b4ipu4().s[46]++, name.replace(/[\]]/g, "\\$&"));
  var regex = (cov_1jr4b4ipu4().s[47]++, new RegExp("[?&] ".concat(paramName, " (=([^&#]*)|&|#|$)")));
  var results = (cov_1jr4b4ipu4().s[48]++, regex.exec(url));
  cov_1jr4b4ipu4().s[49]++;
  if (!results) {
    cov_1jr4b4ipu4().b[22][0]++;
    cov_1jr4b4ipu4().s[50]++;
    return null;
  } else {
    cov_1jr4b4ipu4().b[22][1]++;
  }
  cov_1jr4b4ipu4().s[51]++;
  if (!results[2]) {
    cov_1jr4b4ipu4().b[23][0]++;
    cov_1jr4b4ipu4().s[52]++;
    return '';
  } else {
    cov_1jr4b4ipu4().b[23][1]++;
  }
  cov_1jr4b4ipu4().s[53]++;
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
cov_1jr4b4ipu4().s[54]++;
var convertOtParameterToShopOrderType = function convertOtParameterToShopOrderType(orderTypeIntValue) {
  cov_1jr4b4ipu4().f[10]++;
  var SUPPORT_ORDER_TYPE_BY_ENUM = (cov_1jr4b4ipu4().s[55]++, {
    0: 'SALE',
    1: 'RESERVATION',
    2: 'OPTION'
  });
  cov_1jr4b4ipu4().s[56]++;
  if (!orderTypeIntValue) {
    cov_1jr4b4ipu4().b[24][0]++;
    cov_1jr4b4ipu4().s[57]++;
    // By default no ot in url paramter mean current order type = SALE
    return SUPPORT_ORDER_TYPE_BY_ENUM[0];
  } else {
    cov_1jr4b4ipu4().b[24][1]++;
  }
  cov_1jr4b4ipu4().s[58]++;
  return SUPPORT_ORDER_TYPE_BY_ENUM[orderTypeIntValue];
};
cov_1jr4b4ipu4().s[59]++;
var pushDataLayer = function pushDataLayer(product, user, url, useGA4) {
  cov_1jr4b4ipu4().f[11]++;
  var advantageDataLayer;
  var orderType = (cov_1jr4b4ipu4().s[60]++, convertOtParameterToShopOrderType(getParameterByName('ot', url)));
  cov_1jr4b4ipu4().s[61]++;
  window.dataLayer = (cov_1jr4b4ipu4().b[25][0]++, window.dataLayer) || (cov_1jr4b4ipu4().b[25][1]++, []);
  cov_1jr4b4ipu4().s[62]++;
  if ((0, _size.default)(product.advantages) > 0) {
    cov_1jr4b4ipu4().b[26][0]++;
    cov_1jr4b4ipu4().s[63]++;
    advantageDataLayer = buildOnClickAdvantageDataLayer(product.advantageDataLayer, user, orderType, useGA4);
    cov_1jr4b4ipu4().s[64]++;
    if (advantageDataLayer) {
      cov_1jr4b4ipu4().b[27][0]++;
      cov_1jr4b4ipu4().s[65]++;
      window.dataLayer.push(advantageDataLayer);
    } else {
      cov_1jr4b4ipu4().b[27][1]++;
    }
  } else {
    cov_1jr4b4ipu4().b[26][1]++;
  }
  var productDataLayer = (cov_1jr4b4ipu4().s[66]++, buildOnClickProductDataLayer(product.productDataLayer, user, orderType, useGA4));
  cov_1jr4b4ipu4().s[67]++;
  if (productDataLayer) {
    cov_1jr4b4ipu4().b[28][0]++;
    cov_1jr4b4ipu4().s[68]++;
    window.dataLayer.push(productDataLayer);
  } else {
    cov_1jr4b4ipu4().b[28][1]++;
  }
};
cov_1jr4b4ipu4().s[69]++;
var onHandleClick = function onHandleClick(id, url, currentProduct, onActionClick, ecommerceGoogleTracking) {
  cov_1jr4b4ipu4().f[12]++;
  var _ref4 = (cov_1jr4b4ipu4().s[70]++, ecommerceGoogleTracking),
    useGoogleEnhancedTracking = _ref4.useGoogleEnhancedTracking,
    user = _ref4.user,
    useGA4 = _ref4.useGA4;
  cov_1jr4b4ipu4().s[71]++;
  if (useGoogleEnhancedTracking) {
    cov_1jr4b4ipu4().b[29][0]++;
    cov_1jr4b4ipu4().s[72]++;
    pushDataLayer(currentProduct, user, url, useGA4);
  } else {
    cov_1jr4b4ipu4().b[29][1]++;
  }
  cov_1jr4b4ipu4().s[73]++;
  if (onActionClick) {
    cov_1jr4b4ipu4().b[30][0]++;
    cov_1jr4b4ipu4().s[74]++;
    onActionClick(id, url);
  } else {
    cov_1jr4b4ipu4().b[30][1]++;
  }
};

/**
 * function received the product id & url to produce needed object according the action handler
 * if action handler is null, redirect to the product action URL
 *
 * @param props: contain action handler and product
 * @param {Number} id: product id
 * @param {String} url: action url
 */
cov_1jr4b4ipu4().s[75]++;
var getActionHandler = function getActionHandler(props, id, url) {
  cov_1jr4b4ipu4().f[13]++;
  var _ref5 = (cov_1jr4b4ipu4().s[76]++, props),
    product = _ref5.product,
    performance = _ref5.performance,
    onActionClick = _ref5.onActionClick,
    ecommerceGoogleTracking = _ref5.ecommerceGoogleTracking;
  cov_1jr4b4ipu4().s[77]++;
  if (onActionClick) {
    cov_1jr4b4ipu4().b[31][0]++;
    cov_1jr4b4ipu4().s[78]++;
    return {
      onClick: function onClick() {
        cov_1jr4b4ipu4().f[14]++;
        cov_1jr4b4ipu4().s[79]++;
        return onHandleClick(id, url, (cov_1jr4b4ipu4().b[32][0]++, performance) || (cov_1jr4b4ipu4().b[32][1]++, product), onActionClick, ecommerceGoogleTracking);
      }
    };
  } else {
    cov_1jr4b4ipu4().b[31][1]++;
  }
  var newUrl = (cov_1jr4b4ipu4().s[80]++, (0, _size.default)(url) === 1 ? (cov_1jr4b4ipu4().b[33][0]++, url[0]) : (cov_1jr4b4ipu4().b[33][1]++, url));
  // STX-103651: Add gtmStepTracking=true when pushing data layer for server handling
  cov_1jr4b4ipu4().s[81]++;
  newUrl = ecommerceGoogleTracking.useGoogleEnhancedTracking ? (cov_1jr4b4ipu4().b[34][0]++, (0, _utils.buildUrl)(newUrl, {
    gtmStepTracking: true
  })) : (cov_1jr4b4ipu4().b[34][1]++, newUrl);
  cov_1jr4b4ipu4().s[82]++;
  return {
    onClick: function onClick() {
      cov_1jr4b4ipu4().f[15]++;
      cov_1jr4b4ipu4().s[83]++;
      return onHandleClick(id, newUrl, (cov_1jr4b4ipu4().b[35][0]++, performance) || (cov_1jr4b4ipu4().b[35][1]++, product), null, ecommerceGoogleTracking);
    },
    href: newUrl
  };
};
var _default = exports.default = {
  getProductSubtitle: getProductSubtitle,
  getProductTitle: getProductTitle,
  getVariableByKey: getVariableByKey,
  getActionHandler: getActionHandler,
  pushDataLayer: pushDataLayer,
  addUserInfo: addUserInfo
};